var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterTips(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5ZM9.75 5.25L9.75 6.75L8.25 6.75L8.25 5.25L9.75 5.25ZM9.75 12.75L9.75 8.25L8.25 8.25L8.25 12.75L9.75 12.75Z",
    fill: "#5A87EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTips);
export default __webpack_public_path__ + "static/media/filter-tips.29669dcd8fb654cfe3ac6c2eed8a18a5.svg";
export { ForwardRef as ReactComponent };